
// "use client"

// import Link from "next/link"
// import Image from "next/image"
// import { motion, Variants } from "framer-motion"

// export function Footer() {
//   const fadeUp: Variants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
//     },
//   }

//   return (
//     <footer className="bg-gradient-to-b from-blue-700 via-blue-600 to-blue-800 text-white mt-20 overflow-hidden">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
//         {/* Top grid section */}
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10"
//         >
//           {[
//             {
//               title: "CodifyInstitute",
//               desc: "Master modern development from industry experts.",
//               content: (
//                 <div className="flex items-center gap-3 mb-5">
//                   <div className="relative  rounded-xl overflow-hidden bg-white shadow-lg shadow-blue-400/30">

//                     <Image
//                       src="/logo.png"
//                       alt="CodifyInstitute Logo"
//                       width={200}
//                       height={200}
//                       className="object-contain p-2"
//                     />

//                   </div>
//                 </div>
//               ),
//             },
//             {
//               title: "Learning",
//               links: [
//                 { label: "Courses", href: "/courses" },
//                 { label: "Instructors", href: "/instructors" },
//                 { label: "Blog", href: "/blog" },
//               ],
//             },
//             {
//               title: "Resources",
//               links: [
//                 { label: "About", href: "/about" },
//                 { label: "Events", href: "/events" },
//                 { label: "Offline Lectures", href: "/offline-lectures" },
//                 { label: "Contact", href: "/contact" },
//               ],
//             },
//             {
//               title: "Legal",
//               links: [
//                 { label: "Privacy Policy", href: "#" },
//                 { label: "Terms of Service", href: "#" },
//                 { label: "Cookie Policy", href: "#" },
//               ],
//             },
//           ].map((col, i) => (
//             <motion.div key={i} variants={fadeUp} transition={{ delay: i * 0.1 }}>
//               {col.content ? (
//                 <>
//                   {col.content}
//                   <p className="text-base text-blue-100">{col.desc}</p>
//                 </>
//               ) : (
//                 <>
//                   <h4 className="font-display font-semibold text-xl text-white mb-4">
//                     {col.title}
//                   </h4>
//                   <ul className="space-y-3 text-base">
//                     {col.links?.map((link, idx) => (
//                       <li key={idx}>
//                         <Link
//                           href={link.href}
//                           className="hover:text-yellow-300 transition duration-300 hover:translate-x-1 inline-block"
//                         >
//                           {link.label}
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </>
//               )}
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* Bottom section */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.5, duration: 0.7 }}
//           viewport={{ once: true }}
//           className="border-t border-blue-400/40 pt-8 flex flex-col md:flex-row items-center justify-between"
//         >
//           <p className="text-base text-blue-100">
//             &copy; 2025 CodifyInstitute. All rights reserved.
//           </p>
//           <div className="flex gap-6 mt-4 md:mt-0">
//             {["Twitter", "LinkedIn", "GitHub"].map((platform, idx) => (
//               <motion.a
//                 key={idx}
//                 href="#"
//                 whileHover={{ scale: 1.1, color: "#FFD700" }}
//                 transition={{ duration: 0.2 }}
//                 className="text-blue-100 hover:text-yellow-300 text-lg transition"
//               >
//                 {platform}
//               </motion.a>
//             ))}
//           </div>
//         </motion.div>
//       </div>
//     </footer>
//   )
// }


"use client"

import Link from "next/link"
import Image from "next/image"
import { motion, Variants } from "framer-motion"

export function Footer() {
  const fadeUp: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
    },
  }

  return (
    <footer className="bg-gradient-to-b from-blue-700 via-blue-600 to-blue-800 text-white mt-20 overflow-hidden w-full">
      <div className="w-full py-14 px-4 md:px-8">
        {/* Top grid section */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-5 gap-10 mb-10 text-center md:text-left"
        >
          {/* Logo + text */}
          <motion.div
            variants={fadeUp}
            transition={{ delay: 0.1 }}
            className="flex flex-col items-center md:items-start justify-start"
          >
            <div className="relative rounded-xl overflow-hidden bg-white shadow-lg shadow-blue-400/30 mb-5">
              <Image
                src="/logo.png"
                alt="CodifyInstitute Logo"
                width={200}
                height={200}
                className="object-contain p-2"
              />
            </div>
            <p className="text-base text-blue-100 max-w-xs md:max-w-sm">
              Master modern development from industry experts.
            </p>
          </motion.div>

          {/* Learning */}
          <motion.div variants={fadeUp} transition={{ delay: 0.2 }}>
            <h4 className="font-semibold text-xl mb-4">Learning</h4>
            <ul className="space-y-2 text-base">
              <li><Link href="/syallabus" className="hover:text-yellow-300">Courses</Link></li>
              <li><Link href="/placements" className="hover:text-yellow-300">Placements</Link></li>
              <li><Link href="/about" className="hover:text-yellow-300">About</Link></li>
            </ul>
          </motion.div>

          {/* Resources */}
          <motion.div variants={fadeUp} transition={{ delay: 0.3 }}>
            <h4 className="font-semibold text-xl mb-4">Resources</h4>
            <ul className="space-y-2 text-base">
              <li><Link href="/about" className="hover:text-yellow-300">About</Link></li>
              <li><Link href="/" className="hover:text-yellow-300">Events</Link></li>
              <li><Link href="/" className="hover:text-yellow-300">Blogs</Link></li>
              <li><Link href="/contact" className="hover:text-yellow-300">Contact</Link></li>
            </ul>
          </motion.div>

          {/* Legal */}
          <motion.div variants={fadeUp} transition={{ delay: 0.4 }}>
            <h4 className="font-semibold text-xl mb-4">Legal</h4>
            <ul className="space-y-2 text-base">
              <li><Link href="#" className="hover:text-yellow-300">Privacy Policy</Link></li>
              <li><Link href="#" className="hover:text-yellow-300">Terms of Service</Link></li>
              <li><Link href="#" className="hover:text-yellow-300">Cookie Policy</Link></li>
            </ul>
          </motion.div>

          {/* Google Map */}
          <motion.div
            variants={fadeUp}
            transition={{ delay: 0.5 }}
            className="w-full h-64 rounded-lg overflow-hidden shadow-lg shadow-blue-500/30 md:pr-8"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.8981963801816!2d72.79787467595925!3d19.45995558182529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ab059e821c33%3A0x28d1b7b9c3d25fb9!2sCodify%20Institute!5e0!3m2!1sen!2sin!4v1761967180506!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </motion.div>
        </motion.div>

        {/* Bottom section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.7 }}
          viewport={{ once: true }}
          className="border-t border-blue-400/40 pt-8 flex flex-col md:flex-row items-center justify-between text-center md:text-left"
        >
          <p className="text-base text-blue-100">
            © 2025 CodifyInstitute. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 md:mt-0 justify-center">
            {["Instagram", "LinkedIn", "Youtube"].map((platform, idx) => (
              <motion.a
                key={idx}
                href="#"
                whileHover={{ scale: 1.1, color: "#FFD700" }}
                transition={{ duration: 0.2 }}
                className="text-blue-100 hover:text-yellow-300 text-lg transition"
              >
                {platform}
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </footer>
  )
}
